import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16.014" width="1em" height="1em" {...props}><g fill="#474747"><path d="M11.049 1.823a1 1 0 00-.533 1.87A4.995 4.995 0 0112.9 9.005a4.993 4.993 0 01-4.257 3.97 4.99 4.99 0 01-5.127-2.753 4.993 4.993 0 01.949-5.742A1 1 0 103.05 3.065a7.007 7.007 0 00-1.33 8.04 7.005 7.005 0 007.18 3.85A7.005 7.005 0 0014.858 9.4a7.006 7.006 0 00-3.336-7.434 1 1 0 00-.474-.142z" style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        textOrientation: "mixed",
        shapePadding: 0,
        isolation: "auto",
        mixBlendMode: "normal",
        marker: "none"
      }} color="#000" fontWeight={400} fontFamily="sans-serif" overflow="visible" /><path d="M7.984 0A1 1 0 007 1.015v5a1 1 0 102 0v-5A1 1 0 007.984.001z" style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        textOrientation: "mixed",
        shapePadding: 0,
        isolation: "auto",
        mixBlendMode: "normal"
      }} color="#000" fontWeight={400} fontFamily="sans-serif" overflow="visible" /><path d="M5 1.014c.552 0 1 .475 1 .994v4.006l-5-5z" /></g></svg>;
}

export default SvgComponent;